import {Component, Input, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';

import {Project} from '../../../../../core/models';
import {ProjectService} from '../../../../../core/services';
import {TokenService} from '../../../../../core/auth';

import {BreadcrumbService} from '../../../../../breadcrumb.service';
import {ProjectSidebarService} from '../../../../../projectsidebar.service';

import {combineLatest} from 'rxjs';
import {map} from 'rxjs/operators';
import {forkJoin} from 'rxjs/observable/forkJoin';
import {Detection} from '../../../../../core/models/detection';
import {AccusationResponse} from '../../../../../core/models/accusation';
import {PageRequest} from '../../../../../core/pageRequest';
import {PlayerService} from '../../../../../core/services/project-player.service';

@Component({
  selector: 'app-project-activity-detection-details',
  templateUrl: './project-activity-detection-details.page.html'
})
export class ProjectActivityDetectionDetailsPage implements OnInit {
  project: Project;
  projectId: string;
  detection: Detection;
  detectionId: string;
  authUser = this.token.whoAmI();
  loading = false;

  accusationMode = 'Contributing';
  accusationModes: any = [
    {
      label: 'Contributing', value: 'Contributing', command: (event: any) => {
        this.accusationMode = 'Contributing';
      }
    },
    {
      label: 'All', value: 'All', command: (event: any) => {
        this.accusationMode = 'All';
      }
    }
  ];

  @Input() queryAccusations = new PageRequest();
  allAccusationsResponse = new AccusationResponse();

  constructor(
    private route: ActivatedRoute,
    private token: TokenService,
    private projectService: ProjectService,
    private breadcrumbService: BreadcrumbService,
    private projectSidebarService: ProjectSidebarService,
    private playerService: PlayerService
  ) {
  }

  onSort(event: any) {
    if (event.field === 'creationDate') {
      this.detection.contributingAccusations.sort((a, b) => {
        return (new Date(a.creationDate).getTime() === new Date(b.creationDate).getTime() ? 0 : (new Date(a.creationDate).getTime() < new Date(b.creationDate).getTime() ? -1 : 1)) * event.order;
      });
    } else if (event.field === 'accusation') {
      this.detection.contributingAccusations.sort((a, b) => (a.accusationType.name === b.accusationType.name ? 0 : (a.accusationType.name < b.accusationType.name ? -1 : 1)) * event.order);
    } else {
      this.detection.contributingAccusations.sort((a, b) => (a.session.id === b.session.id ? 0 : (a.session.id < b.session.id ? -1 : 1)) * event.order);
    }
  }

  /**
   * Resolve route params.
   */
  ngOnInit() {
    combineLatest(this.route.parent.params, this.route.params)
      .pipe(map(results => ({projectId: results[0].id, detectionId: results[1].detectionId})))
      .subscribe(result => {
        this.init(result.projectId, result.detectionId);
      });
  }

  /**
   * Load match, project and detections
   */
  init(projectId: string, detectionId: string) {
    this.loading = true;

    const subs = [];
    subs.push(this.projectService.getDetection(detectionId, projectId));
    subs.push(this.projectService.getOne(projectId));

    forkJoin(subs).subscribe(
      (results) => {
        this.detection = <Detection>results[0];
        this.project = results[1];

        this.breadcrumbService.setItems([
          {label: 'projects', routerLink: ['/project', 'list']},
          {label: this.project.name},
          {label: 'detection', routerLink: ['/project', this.project.id, 'activity', 'detection']},
          {label: this.detection.id}
        ]);

        this.loading = false;
      },
      (error) => {
        this.loading = false;
      });
  }

  loadAccusations(query) {
    query.projectId = this.project.id;
    this.playerService.getAccusations(this.detection.player.id, query).subscribe(
      (playerData) => {
        this.allAccusationsResponse = playerData;
      }
    );
  }

  paginateAccusation(event) {
    this.queryAccusations.page = (event.first / event.rows) + 1;
    this.queryAccusations.sortField = event.sortField !== undefined ? event.sortField : 'creationDate';
    this.queryAccusations.sortDir = this.queryAccusations.getSortDir(event.sortOrder);
    this.loadAccusations(this.queryAccusations);
  }

}
